<template>
  <g>
    <g v-if="activeHohlschnitt && materialComplete">
      <path :d="'M75 425 q175 -30 350 0 q' + bXhohlschnitt + ' ' + bYhohlschnitt + ' -175 -350 q' + aXhohlschnitt + ' ' + aYhohlschnitt + ' -175 350'" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
      <polygon v-for="(corner, index) in hohlschnitt" :key="index" :points="corner.point" :transform="'rotate(' + corner.rotate + ')'" stroke="#b1b1b1" stroke-width="2" fill="#fff"/>
    </g>
    <polygon v-else points="75,425 425,425 250,75" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <g v-for="(side, index) in sides" :key="index">
        <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
      </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === rand.saum.titleSaum.name">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="activeOesenArt">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === rand.hohlsaum.title.name" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
        <g v-if="side.rand === rand.keder.title.name" stroke="#b1b1b1" stroke-opacity="0">
          <polygon :points="side.keder.outside" fill="#b1b1b1"/>
          <polygon :points="side.keder.inside" fill="#8e8e8e"/>
        </g>
      </g>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt,
      aXhohlschnitt: -87.5 + Math.sqrt(720),
      aYhohlschnitt: 175 + 1 / 2 * Math.sqrt(720),
      bXhohlschnitt: -87.5 - Math.sqrt(720),
      bYhohlschnitt: -175 + 1 / 2 * Math.sqrt(720),
      hohlschnitt: {
        cornerMU: {
          point: '245,80 245,70 255,70',
          rotate: '45 250 75'
        },
        cornerLD: {
          point: '70,420 70,430 80,430',
          rotate: '10 75 425'
        },
        cornerRD: {
          point: '430,420 430,430 420,430',
          rotate: '-10 425 425'
        }
      }
    }
  },
  methods: {
    spaceRand (x, y) {
      return (Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)))
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'activeHohlschnitt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            xStart: (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2 + 75,
            xEnd: 425 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M90 395 L410 395',
          hohlsaum: 'M79.5 416 L420.5 416',
          keder: {
            outside: '75,425 79.5,416 420.5,416 425,425',
            inside: '75,425 76.5,422 423.5,422 425,425'
          },
          labelSpace: {
            x: 250,
            y: 455
          },
          labelBackground: {
            x: 215,
            y: 437,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 75,
              yStart: 465,
              xEnd: 425,
              yEnd: 465
            },
            corner: {
              start: '75,465 85,460 85,470',
              rotateStart: 'rotate(0, 75, 465)',
              end: '425,465 415,460 415,470',
              rotateEnd: 'rotate(0, 425, 465)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            xStart: (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2,
            xEnd: 250,
            x: function (i, item) {
              if (item === 1) {
                return ((75 + this.xStart) + this.xEnd) / 2
              } if (item === 2) {
                return (this.xStart + 75) + i * (this.xEnd - (this.xStart + 75))
              } else {
                return (this.xStart + 75) + (i / (item - 1)) * (this.xEnd - (this.xStart + 75))
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return 425 - (2 * (((75 + this.xStart) + this.xEnd) / 2 - 75) - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2)))
              } else if (item === 2) {
                return 410 - i * (2 * (175 - this.xStart))
              } else {
                return 410 - (i / (item - 1)) * (2 * (175 - this.xStart))
              }
            }
          },
          saum: 'M' + (75 + this.spaceRand(15, 30)) + ' 425 L' + (250 + this.spaceRand(15, 30) / 2) + ' ' + (75 + this.spaceRand(15, 30)),
          hohlsaum: 'M' + (75 + this.spaceRand(4.5, 9)) + ' 425 L' + (250 + this.spaceRand(4.5, 9) / 2) + ' ' + (75 + this.spaceRand(4.5, 9)),
          keder: {
            outside: '75,425 ' + (75 + this.spaceRand(4.5, 9)) + ',425 ' + (250 + this.spaceRand(4.5, 9) / 2) + ',' + (75 + this.spaceRand(4.5, 9)) + ' 250,75',
            inside: '75,425 ' + (75 + this.spaceRand(1.5, 3)) + ',425 ' + (250 + this.spaceRand(1.5, 3) / 2) + ',' + (75 + this.spaceRand(1.5, 3)) + ' 250,75'
          },
          labelSpace: {
            x: 110,
            y: 230
          },
          labelBackground: {
            x: 75,
            y: 215,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 35,
              yStart: 405,
              xEnd: 210,
              yEnd: 55
            },
            corner: {
              start: '35,405 30,395 40,395',
              rotateStart: 'rotate(27, 35, 405)',
              end: '210,55 205,65 215,65',
              rotateEnd: 'rotate(27, 210, 55)'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          size: Math.round(this.calcSides[2]),
          rand: this.randSides[2].type.name,
          oesenAnzahl: this.randSides[2].oesenAnzahl,
          oesenAbstand: {
            xStart: 250,
            xEnd: 425 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return 425 - (-2 * (this.xStart + this.xEnd - 150) / 2 + 700 - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2)))
              } else if (item === 2) {
                return 425 - (-2 * (this.xStart - 75) + 700 - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) - i * (-2 * (175 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2))
              } else {
                return 425 - (-2 * (this.xStart - 75) + 700 - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) - (i / (item - 1)) * (-2 * (175 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2))
              }
            }
          },
          saum: 'M' + (250 - this.spaceRand(15, 30) / 2) + ' ' + (75 + this.spaceRand(15, 30)) + ' L' + (425 - this.spaceRand(15, 30)) + ' 425',
          hohlsaum: 'M' + (250 - this.spaceRand(4.5, 9) / 2) + ' ' + (75 + this.spaceRand(4.5, 9)) + ' L' + (425 - this.spaceRand(4.5, 9)) + ' 425',
          keder: {
            outside: '250,75 ' + (250 - this.spaceRand(4.5, 9) / 2) + ',' + (75 + this.spaceRand(4.5, 9)) + ' ' + (425 - this.spaceRand(4.5, 9)) + ',425 425,425',
            inside: '250,75 ' + (250 - this.spaceRand(1.5, 3) / 2) + ',' + (75 + this.spaceRand(1.5, 3)) + ' ' + (425 - this.spaceRand(1.5, 3)) + ',425 425,425'
          },
          labelSpace: {
            x: 390,
            y: 230
          },
          labelBackground: {
            x: 355,
            y: 215,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 465,
              yStart: 405,
              xEnd: 290,
              yEnd: 55
            },
            corner: {
              start: '465,405 460,395 470,395',
              rotateStart: 'rotate(-27, 465, 405)',
              end: '290,55 285,65 295,65',
              rotateEnd: 'rotate(-27, 290, 55)'
            }
          },
          id: 3
        }
      }
    }
  }
}
</script>

<style>
</style>
